module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-3840-db54bf41ae3505fb7bdc0b0ab03c7df7.webp";